// Core/pages/NewPassword.tsx
import React from 'react';
import {useNavigate} from "react-router-dom";
import {Message} from "Core/components/Message";
import NewPasswordForm from "Auth/forms/NewPasswordForm";
import {DOMAIN_URL} from "Auth/axiosConfig";
import Head from "Core/components/Head";

const NewPassword = () => {
    const navigate = useNavigate();
    const onSuccess = () => {
        navigate('/profile')
        Message.success('Пароль успешно изменен');
    }
    return (
        <div className={'fccc gap-2 maxw-400px mx-auto'}>
            <Head
                title={'Пароль | Лайф Хелп'}
                description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
                robots={'noindex, nofollow'}
                canonicalUrl={`${DOMAIN_URL}/new-password`}
            />
            <h1 className={'fs-2 m-0'}>Новый пароль</h1>
            <NewPasswordForm onSuccess={onSuccess}/>
        </div>
    );
};

export default NewPassword;
